<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Información de la Orden de Cobro">
          <b-table 
              class="data-display" 
              small
              responsive="sm" 
              :items="cobroDatos" 
              :fields="fields">
            <template v-slot:cell(valor)="data">
              {{ formattedData(data.item) }}
            </template>
          </b-table>
        </b-card>
        <b-card header="Comprobantes" v-if="cobroComprobantes.length != 0">
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes"
              :items="cobroComprobantes" 
              :fields="comprobantesFields">
            <template v-slot:cell(fechaRegistro)="data">
              {{ data.item.fechaRegistro | fecha }}
            </template>
            <template v-slot:cell(fechaVencimiento)="data">
              {{ data.item.fechaVencimiento | fecha }}
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda(data.item.moneda) }}
            </template>
            <template v-slot:cell(importeCobro)="data">
              {{ data.item.importeCobro | moneda(data.item.moneda) }}
            </template>
          </b-table>
        </b-card>
        <b-card header="Efectivo" v-if="cobroDocumentos.length != 0">
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes"
              :items="cobroDocumentos" 
              :fields="documentosFields">
            <template v-slot:cell(documentoNumero)="data">
              {{ data.item.documentoNumero }}
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda }}
            </template>
          </b-table>
        </b-card>
        <b-card header="Cheques" v-if="cobroChequesTerceros.length != 0">
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes"
              :items="cobroChequesTerceros" 
              :fields="chequesTercerosFields">
            <template v-slot:cell(fechaEmision)="data">
              {{ data.item.fechaEmision | fecha }}
            </template>
            <template v-slot:cell(fechaPago)="data">
              {{ data.item.fechaPago | fecha }}
            </template>
            <template v-slot:cell(numero)="data">
              <template v-if="!data.item.sinNumero" >
                {{ data.item.numero }}
              </template>
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda }}
            </template>
          </b-table>
        </b-card>
        <b-card header="Transferencias" v-if="cobroTransferencias.length != 0">
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes"
              :items="cobroTransferencias" 
              :fields="transferenciasFields">
            <template v-slot:cell(fechaCreditoDebito)="data">
              {{ data.item.fechaCreditoDebito | fecha }}
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda(data.item.moneda) }}
            </template>
          </b-table>
        </b-card>
        <b-card header="Retenciones" v-if="cobroRetencionesClientes.length != 0">
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes"
              :items="cobroRetencionesClientes" 
              :fields="retencionesClientesFields">
            <template v-slot:cell(fechaComprobante)="data">
              {{ data.item.fechaComprobante | fecha }}
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda(data.item.moneda) }}
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="data-goback-btn" @click.prevent="goBack">
          <i class="fa fa-undo fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'cobro/getField',
  mutationType: 'cobro/updateField',
});

export default {
  name: 'Cobro',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data: () => {
    return {
      pagoId: 0,
      fields: [
        {key: 'campo'},
        {key: 'valor'},
      ],

      comprobantesFields: [
        { 
          key: 'fechaRegistro',
          label: 'Fecha'
        },
        { key: 'fechaVencimiento' },
        { 
          key: 'comprobanteTipo',
          label: 'Comprobante'
        },
        { 
          key: 'comprobanteNumero',
          label: 'Nro.Comprobante'
        },
        { 
          key: 'importe',
          class: 'text-right'
        },
        { 
          key: 'importeCobro',
          class: 'text-right'
        },
      ],

      documentosFields: [
        { 
          key: 'documentoTipo',
          label: 'Moneda'
        },
        { 
          key: 'importe',
          class: 'text-right'
        },
      ],

      chequesTercerosFields: [
        { key: 'fechaEmision' },
        { key: 'fechaPago' },
        { key: 'titular' },
        { key: 'titularCuit' },
        { key: 'banco' },
        { key: 'serie' },
        {
          key: 'numero',
          class: 'text-right',
        },
        {
          key: 'importe',
          class: 'text-right',
        },
      ],

      transferenciasFields: [
        { 
          key: 'fechaCreditoDebito',
          label: 'Fecha Pago' 
        },
        { 
          key: 'bancoCuenta',
          label: 'Cuenta'
        },
        {
          key: 'importe',
          class: 'text-right',
        },
      ],

      retencionesClientesFields: [
        {
          key: 'fechaComprobante',
          label: 'Fecha'
        },
        {
          key: 'retencionTipo',
          label: 'Tipo',
        },
        {
          key: 'retencionRegimen',
          label: 'Regimen',
        },
        {
          key: 'jurisdiccion',
          label: 'Jurisdicción',
        },
        { 
          key: 'importe',
          class: 'text-right'
        },
      ],
    }
  },
  created() {
    this.pagoId = this.$route.params.id;

    this.$store.dispatch('cobro/getDatos', this.pagoId)
      .catch(error => this.showErrorMsj(error));
  },  
  computed: {
    ...mapFields([
      'cobroDatos',
      'cobroComprobantes',
      'cobroDocumentos',
      'cobroChequesTerceros',
      'cobroTransferencias',
      'cobroRetencionesClientes'
    ]),
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  }
}
</script>
